// React
import React from "react";
// React
// models
import { I_QuizMakerQuestions } from "../Models/interfaces";
// models

export const UserQuestionsContext = React.createContext<I_QuizMakerQuestions[]>(
  []
);
